import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as actions from '../actions';
import * as qs from 'qs';

export interface RequiresAuthenticationProps {
}

type HOC<PWrapped, PHoc> = React.ComponentClass<PWrapped & PHoc>;

// tslint:disable-next-line:variable-name
export const requiresAuthentication = <P, S>(Component: HOC<P, RequiresAuthenticationProps>):
  React.ComponentClass<P> => {

  class C extends React.Component<P & RequiresAuthenticationProps, S> {

    componentDidMount() {
      const { isAuthenticated } = (this.props as any).state.authState;
      const { location } = (this.props as any).state.routerState;
      const hashString = location && location.hash;
      const params: any = hashString && hashString.length > 1 && qs.parse(hashString.slice(1));
      
      if (!isAuthenticated) {
        if (location && params && params.autoAuth && params.autoAuth === 'true') {
          (this.props as any).dispatch(actions.loginWithQueryParam());
          return;
        } 
        (this.props as any).dispatch(push('/'));
      }
    }

    public render(): (JSX.Element | null) {
      const { isAuthenticated } = (this.props as any).state.authState;
      
      const { ...rest } = this.props as any;
      return (isAuthenticated ? <Component {...rest} /> : null);
    }
  }

  const mapStateToProps = (state: any, ownProps: P): RequiresAuthenticationProps => ({
    state,
  });

  return connect(mapStateToProps)(C);

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/requiresAuthentication.tsx